import { useEffect } from 'react';
import { useAccountHealthStore } from '@/shared/stores/account-health-store';
import { accountsNeedingReconnect } from '@/shared/utils/account-health';
import { useAccounts } from '../api/accounts-queries';

/**
 * Keeps the app-wide credential-health count in sync with the accounts query.
 *
 * Mounted once by the app shell so the sidebar badge is correct on every page,
 * not just after the user happens to open the accounts page. The query is
 * shared with that page through the react-query cache, so this costs one
 * request per session rather than one per navigation.
 */
export function useAccountHealthSync(): void {
  const { data: accounts } = useAccounts();
  const setReconnectCount = useAccountHealthStore((s) => s.setReconnectCount);

  useEffect(() => {
    // `undefined` means "not loaded yet" — leave the previous count alone so
    // the badge doesn't blink off on every refetch.
    if (!accounts) return;
    setReconnectCount(accountsNeedingReconnect(accounts).length);
  }, [accounts, setReconnectCount]);
}
